import React from 'react'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { find } from 'lodash'

import { MultiSelect, Button, Textarea, Form } from 'components/Forms'
import { Alert } from 'ui'
import { t } from 'translations'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import PunchService from 'services/PunchService'

import { useBreaks } from 'Api'

const PunchStartBreakModal = ({ punchCard, breaks }) => {
  const dispatch = useDispatch()
  const { userInfo } = useSelector(state => state.users)
  const { data } = useBreaks()
  const breaksAvailable = data.breaks || []

  const breakOptions = [
    ...breaks
      .map(breakOption => {
        if (find(breaksAvailable, ['name', breakOption.name])?.preventPunching) return null
        // Prevents a user from starting a break they have already taken
        const breakInPunchCard = find(punchCard.breaks, { _id: breakOption._id })
        if (breakInPunchCard && breakInPunchCard.start) return null
        return { value: breakOption, label: breakOption.name }
      })
      .filter(Boolean),
    { value: 'customBreak', label: t(`employee.punch.CUSTOM_BREAK`) }
  ]
  return (
    <BaseModal hideButtons title="employee.punch.BREAK_START_MODAL">
      <Formik
        enableReinitialize={true}
        initialValues={{ selectedBreak: '', reason: '' }}
        onSubmit={({ selectedBreak, customBreakReason }) => {
          // If taking a custom break
          if (selectedBreak === 'customBreak') PunchService.startBreak(punchCard._id, { reason: customBreakReason, unplanned: true }, userInfo)
          // Else if normal break
          else PunchService.startBreak(punchCard._id, selectedBreak, userInfo)
          dispatch(closeModal())
        }}
      >
        {({ values, status, isSubmitting, setStatus }) => {
          return (
            <Form className="mt-2">
              {/* Error message */}
              <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                {status?.msg}
              </Alert>
              <MultiSelect module="employee.punch" name="selectedBreak" options={breakOptions} />
              {values.selectedBreak === 'customBreak' && <Textarea module="employee.punch" required name="customBreakReason" autoComplete="false" />}
              <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} disabled={!values.selectedBreak} text="SUBMIT" />
              <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default PunchStartBreakModal
